import React from 'react';
import { Menu } from '@headlessui/react';
import Avatar from '../ds/Avatar';
import Badge from '../ds/Badge';

/** DELETE /users/sign_out via a hidden Rails-style form (Devise expects DELETE). */
export function signOut() {
  const form = document.createElement('form');
  form.method = 'post';
  form.action = '/users/sign_out';
  const method = document.createElement('input');
  method.type = 'hidden';
  method.name = '_method';
  method.value = 'delete';
  form.appendChild(method);
  const csrf = document.querySelector('meta[name="csrf-token"]');
  if (csrf) {
    const token = document.createElement('input');
    token.type = 'hidden';
    token.name = 'authenticity_token';
    token.value = csrf.content;
    form.appendChild(token);
  }
  document.body.appendChild(form);
  form.submit();
}

const itemStyle = (active) => ({
  display: 'block', width: '100%', textAlign: 'left', padding: '9px 14px',
  fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)', letterSpacing: 'var(--track-tight)',
  color: 'var(--ink)', textDecoration: 'none', border: 'none', cursor: 'pointer',
  background: active ? 'var(--neutral-50)' : 'transparent', appearance: 'none',
});

function MenuLink({ href, children }) {
  return (
    <Menu.Item>
      {({ active }) => <a href={href} style={itemStyle(active)}>{children}</a>}
    </Menu.Item>
  );
}

const CERT_TONES = { gold: 'solid', silver: 'neutral', bronze: 'human' };

export default function AccountMenu({ user }) {
  const name = [user.first_name, user.last_name].filter(Boolean).join(' ');
  return (
    <Menu as="div" style={{ position: 'relative', display: 'inline-flex' }}>
      <Menu.Button aria-label="Account menu" style={{ appearance: 'none', border: 'none', background: 'transparent', padding: 0, cursor: 'pointer', display: 'inline-flex' }}>
        <Avatar name={name} src={user.avatar_url} size="sm" tone="human" />
      </Menu.Button>
      <Menu.Items style={{
        position: 'absolute', right: 0, top: 'calc(100% + 8px)', zIndex: 40, minWidth: 230,
        background: 'var(--neutral-0)', border: '1px solid var(--line)',
        borderRadius: 'var(--radius-lg)', boxShadow: 'var(--shadow-lg)',
        padding: '8px 0', outline: 'none',
      }}>
        <div style={{ padding: '10px 14px 12px', borderBottom: '1px solid var(--line)', marginBottom: 6 }}>
          <div style={{ fontFamily: 'var(--font-sans)', fontWeight: 'var(--w-bold)', fontSize: 'var(--text-sm)', letterSpacing: 'var(--track-tight)' }}>{name}</div>
          <div style={{ fontSize: 'var(--text-xs)', color: 'var(--ink-muted)', marginBottom: 6 }}>{user.account && user.account.name}</div>
          {user.certification_level && (
            <Badge tone={CERT_TONES[user.certification_level] || 'neutral'}>
              {user.certification_level} certified
            </Badge>
          )}
        </div>
        {user.account && <MenuLink href={`/accounts/${user.account.id}`}>Account settings</MenuLink>}
        <MenuLink href="/account/password">Password</MenuLink>
        <MenuLink href="/accounts">Accounts</MenuLink>
        <MenuLink href="/accounts">Switch account</MenuLink>
        {user.admin && (
          <>
            <div style={{ borderTop: '1px solid var(--line)', margin: '6px 0' }} />
            <MenuLink href="/admin">Admin dashboard</MenuLink>
            <MenuLink href="/admin/sidekiq">Sidekiq</MenuLink>
          </>
        )}
        <div style={{ borderTop: '1px solid var(--line)', margin: '6px 0' }} />
        <Menu.Item>
          {({ active }) => (
            <button onClick={signOut} style={itemStyle(active)}>Sign out</button>
          )}
        </Menu.Item>
      </Menu.Items>
    </Menu>
  );
}
